module.exports = __webpack_public_path__ + "media/img/pages/profile/kpmg ger 14-7ca4e390aefcd89dafd274cf8b68b0ea.jpg";